import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Card } from '@node-space/ui-components'
import { EarnSummaryItem, EarnSummaryItemVariant } from './EarnSummaryItem'

export interface EarnSummaryProps {
  allocatedFunds: string
  availableFunds: string
  totalAllTimeEarnings?: string
}

export const EarnSummary = ({
  allocatedFunds,
  availableFunds,
  totalAllTimeEarnings,
}: EarnSummaryProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="static" emphasis full borderRadius={12} testId="earn-summary">
      <Box flex gap={24} align="center" className="max-sm:flex-col max-sm:items-start">
        <EarnSummaryItem
          label={t('earn.myAllocatedFunds')}
          value={allocatedFunds}
          variant={EarnSummaryItemVariant.LARGE}
        />
        <EarnSummaryItem
          label={t('earn.myAvailableFunds')}
          value={availableFunds}
          variant={EarnSummaryItemVariant.LARGE}
        />

        {totalAllTimeEarnings && (
          <EarnSummaryItem
            label={t('earn.totalAllTimeEarnings')}
            value={totalAllTimeEarnings}
            variant={EarnSummaryItemVariant.LARGE}
          />
        )}
      </Box>
    </Card>
  )
}
